module.exports = __webpack_public_path__ + "static/media/security.56ee43b5.jpg";